var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.861 15.83l4.639 4.638L20.968 22l-4.638-4.639a9.703 9.703 0 01-6.083 2.133C4.867 19.494.5 15.127.5 9.747S4.867 0 10.247 0s9.747 4.367 9.747 9.747a9.703 9.703 0 01-2.133 6.083zm-2.172-.803a7.556 7.556 0 002.139-5.28 7.579 7.579 0 00-7.581-7.581 7.578 7.578 0 00-7.581 7.581 7.579 7.579 0 007.581 7.581 7.556 7.556 0 005.28-2.139l.162-.162z"
  })));
}
export default SvgSearch;